export default "__VITE_ASSET__CFqkMjXU__"